import { ref } from 'vue';
import { useRuntimeConfig } from '@/composables/useRuntimeConfig';

const avisoManutencaoVisivel = ref(false);

export function useModoManutencao() {
  const { modoManutencao } = useRuntimeConfig();

  function exibirAvisoManutencao() {
    avisoManutencaoVisivel.value = true;
  }

  function fecharAvisoManutencao() {
    avisoManutencaoVisivel.value = false;
  }

  return { modoManutencao, avisoManutencaoVisivel, exibirAvisoManutencao, fecharAvisoManutencao };
}
